module.exports = __webpack_public_path__ + "img/logo1.fe41b333.png";